import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import LoginLinkMixin from '@/helpers/vue_mixins/LoginLinkMixin';
import AuthMixin from '@/helpers/vue_mixins/v2/AuthMixin';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import AesMixin from '@/helpers/vue_mixins/v2/AesMixin';
import FbLoginButton from '@/components/auth/FbLoginButton.vue';
import LoginWrapper from '@/components/v2/LoginWrapper.vue';
import { UserType } from '@/helpers/entities/enums/UserType';
import FacebookLogin from '@/plugins/graphql/mutations/facebook-login.gql';
import { resetStore } from '@/plugins/vue-apollo';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import UserPilotMixin from '@/helpers/vue_mixins/v2/UserpilotMixin';
import me from '@/plugins/graphql/queries/me.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let Login = class Login extends Mixins(Mixins(AuthMixin, AlertMixin, SegmentAnalyticsMixin, LoginLinkMixin), AesMixin, UserPilotMixin, AffiliateMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.validTypes = Object.values(UserType);
    }
    authResetStore(block) {
        resetStore().then(block);
    }
    signIn(token) {
        const role = this.$route.params.userType;
        const invitationToken = this.$router.currentRoute.query.invitation_token;
        this.$apollo
            .mutate({
            mutation: FacebookLogin,
            variables: {
                input: {
                    token: this.encrypt(token),
                    role,
                    invitationToken: this.encrypt(invitationToken),
                },
            },
        })
            .then((result) => {
            const data = result.data.facebookLogin;
            const plan = this.$router.currentRoute.query.plan_type;
            const code = this.$router.currentRoute.query.affiliate_code;
            this.authenticate(data.jwt, this.userType);
            this.authResetStore(() => {
                this.$store.commit('navigation_drawer/toggleDrawer');
                this.$apollo
                    .query({
                    query: me,
                })
                    .then((meQuery) => {
                    const profile = meQuery.data.me;
                    this.onLogin(profile);
                    if (role === UserType.Reseller) {
                        this.goToAffiliate(profile.uuid);
                    }
                    else if (role === UserType.NetworkDistributor) {
                        this.goToNetworkDistributor(profile.uuid);
                    }
                    else if (role === UserType.Affiliate) {
                        this.$store.commit('setIsAffiliateMerchant', true);
                        if (data.newUser) {
                            this.$router.push({
                                name: 'affiliate-v2-sign-up',
                                params: { userUuid: profile.uuid },
                            });
                        }
                        else {
                            this.$store.commit('populateAppUUID', profile.firstAppUuid);
                            this.$store.commit('navigation_drawer/toggleDrawer', true);
                            this.$router.push({
                                name: 'affiliate-step-redirecter',
                                params: { routeIsAffiliateBundle: 'true', appUuid: profile.firstAppUuid },
                            });
                        }
                    }
                    else {
                        if (role === UserType.AffiliateManager) {
                            this.$router.push('/apps');
                        }
                        else {
                            this.$router.push(this.buildLoginLink(plan, code, !data.forActivation));
                        }
                        this.segmentIdentify(data.uid, {
                            name: `${profile.firstName} ${profile.lastName}`,
                            email: profile.email,
                        });
                    }
                });
            });
            this.resetClient(data.jwt);
        })
            .catch((e) => {
            this.errorNotification(`Ooops!! Something went wrong details: ${e.message}`);
        });
    }
    mounted() {
        if (!this.validTypes.includes(this.userType)) {
            this.$router.push('/');
        }
        this.viewLoginPage();
    }
};
__decorate([
    Prop({ required: true })
], Login.prototype, "userType", void 0);
Login = __decorate([
    Component({
        components: {
            FbLoginButton,
            LoginWrapper,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = false;
                return true;
            });
        },
    })
], Login);
export default Login;
